import { useApolloClient } from '@apollo/client'
import { CHECK_EMAIL_AVAILABILITY_QUERY } from '../../gql/queries'
import { useToasts } from '../../components/complex/Toast'
import { t } from '../i18n'
import React from 'react'

const useEmailCheck = ({
  email,
  onContinue,
  onPendingInvitation,
  isGift,
  overrideInvitation
}: {
  email: string
  onContinue: () => void
  onPendingInvitation?: (data: any) => void
  isGift?: boolean
  overrideInvitation?: boolean
}) => {
  const { addToast } = useToasts()
  const client = useApolloClient()

  return async () => {
    const { data } = await client.query({
      query: CHECK_EMAIL_AVAILABILITY_QUERY,
      variables: { email }
    })

    const result = data.checkEmailAvailability

    if (!result.exists) {
      onContinue()
      return
    }

    if (result.hasPendingInvitation) {
      if (isGift) {
        addToast(
          t(
            'This email has a pending team invitation. Please contact support.'
          ),
          'danger'
        )
        return
      }

      if (overrideInvitation) {
        onContinue()
        return
      }

      if (onPendingInvitation) {
        onPendingInvitation(result)
        return
      }
    }

    const message = isGift ? (
      t('User already exists. Please contact support.')
    ) : (
      <>
        {t('You already have a Worship Online account. Please ')}
        <a
          href="/signin"
          style={{
            textDecoration: 'underline'
          }}
        >
          {t('Sign in')}
        </a>
        {t(' to reactivate.')}
      </>
    )

    if (result.user) {
      addToast(message, 'danger')
    } else {
      onContinue()
    }
  }
}

export default useEmailCheck
